import React from "react";
import { useForm } from "react-final-form";
import { useHistory } from "react-router";
import { Col, Row } from "reactstrap";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import Icon, { IconName } from "src/components/Icon/Icon";
import * as S from "src/constants/StringConstants";
import { GMEGSIEntity, schoolToOption } from "./GMEGSIEntity";

interface GMEDetailsProps {
  selectedSchools: GMEGSIEntity[];
  availableSchools: GMEGSIEntity[];
  applicationId: string;
}

const GMEDetails = ({ selectedSchools, availableSchools, applicationId }: GMEDetailsProps) => {
  const history = useHistory();
  const form = useForm();
  const value = form.getState().values.school;

  const handleAddGMESchoolClick = () => {
    history.push(`/applications/${applicationId}/add-gme-gsi?type=gme`);
  };

  const activeCurrent = selectedSchools.find(school => school.gid === value);
  const currValue = availableSchools.find(school => school.gid === value);

  if (!activeCurrent && currValue) {
    selectedSchools.push(currValue);
  }

  return (
    <Col sm="6">
      <Row>
        <Col sm="3" className="app-form-header">
          <h4 className="form-title">{S.APP_GME_DETAILS_TITLE}</h4>
        </Col>
      </Row>

      <Row>
        <Col sm="5">
          <TypeaheadField
            name="school"
            label={S.APP_GME_DETAILS_FIELD_SCHOOL}
            options={selectedSchools.map(schoolToOption)}
          />
        </Col>

        <Col sm="5" className="d-flex align-items-center">
          <button className="app-gme-gsi__add-button" onClick={handleAddGMESchoolClick}>
            <Icon name={IconName.PlusBlue} size="24px" />
            <span>{S.APP_GME_DETAILS_BUTTON_ADD_SCHOOL}</span>
          </button>
        </Col>
      </Row>
    </Col>
  );
};

export default GMEDetails;
